import { colors } from "healthex-common/colors";
import { fontSizes } from "healthex-common/sizes";
import { fontWeights } from "healthex-common/weights";
import styled from "styled-components";
import { NestedContentRadioGroup } from "./AdminFormShared.styles";
import { HXTextField } from "./base.styles";
import { FlexColumnDiv } from "./common.styles";
import { SlateChip } from "./HXDesktopChips.styles";
import { Text } from "./HXDesktopPage.styles";
export const MonoTextField = styled(HXTextField) `
    & input {
        font-family: monospace;
    }
`;
export const ScopeRadioGroup = styled(NestedContentRadioGroup) `
    & > button {
        min-height: 64px;
        padding: 8px 8px;
        border-radius: 0;
    }
`;
export const FieldHelp = styled.div `
    font-size: ${fontSizes.TINY};
    color: ${colors.black_lighter};
    margin-top: 4px;
`;
export const ScopeDetail = styled.div `
    padding-left: 32px;

    & .MuiFormControl-root {
        width: 100%;
    }
`;
export const EventLabel = styled(FlexColumnDiv) `
    gap: 2px;
`;
export const EventTitleRow = styled.div `
    display: flex;
    align-items: center;
    gap: 8px;
`;
export const EventTitle = styled(Text).attrs({ color: colors.black_main }) `
    font-family: monospace;
    font-size: ${fontSizes.LITTLE};
    font-weight: ${fontWeights.SEMI_BOLD};
`;
export const EventDescription = styled(Text).attrs({ color: colors.black_lighter }) `
    font-size: ${fontSizes.TINY};
`;
export const ComingSoonChip = styled(SlateChip) `
    text-transform: none;
    font-size: ${fontSizes.TINY};
    height: auto;
    padding: 2px 0px;
    color: ${colors.black_30};
    border-color: ${colors.black_30};
    background: ${colors.black_10};
`;
